<template>
  <v-container ref="container" :style="{'overflow-y': 'auto', 'padding-left':'0px', 'padding-right':'0px', 'height':(display.main.innerHeight-120)+'px'}">
    <div id="emptyMessage" v-if="distribution_age == null && distribution_duration == null && distribution_disease == null">Click on a node to get information</div> 

    <div id="distribution_age" v-if="distribution_age">
      <v-subheader class="pa-2">Age Distribution (patients/years)</v-subheader>
      <histogram-view 
        :padding="[0, 10, 20, 60]" 
        :width="display.side.width-70" 
        :height="((display.main.innerHeight - 150)/4)" 
        :color=requested.color
        :chartdata="distribution_age"
      />
    </div>

    <div id="distribution_duration" v-if="distribution_duration">
      <v-subheader class="pa-2" style="margin-top: 30px;">Patient Record Duration (patients/days)</v-subheader>
      <histogram-view 
        :padding="[0, 10, 20, 60]" 
        :width="display.side.width-70" 
        :height="((display.main.innerHeight - 150)/4)" 
        :color=requested.color
        :chartdata="distribution_duration"
      />
    </div>

    <div id="distribution_disease" v-if="distribution_disease">
      <v-subheader class="pa-2" style="margin-top: 30px;">Disease Distribution (% of patients)</v-subheader>
      <barchart-view :padding="[10, 10, 20, 60]" :width="display.side.width-70" :height="((display.main.innerHeight - 150)/4)" :chartdata="distribution_disease" :domain="diseases.map(d => d.name)" :colordomain="diseases.reduce((a, d) => ({...a, [d.name]: d.color}), {})" :nbValues="distribution_nbValues"/>
    </div>
  </v-container>
</template>

<script>
import HistogramView from "../HistogramView"
import BarchartView  from "../BarchartView"
import { mapGetters } from 'vuex'

export default {
  data(){
    return {}
  },
  components: {
    HistogramView,
    BarchartView,
  },
  watch: {
  },
  computed: {
    ...mapGetters(['distribution_age', 'distribution_duration', 'distribution_disease', 'distribution_nbValues', 'display', 'diseases', 'requested'])
  },
};
</script>
<style>
.mean{
  stroke: black;
  stroke-width: 1px;
  
}
.median{
  stroke: black;
  stroke-width: 1px;
  stroke-dasharray: 5 5;
}
</style>
